import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { ApiError } from '../../../core/models/api-error.model';

export abstract class AuthErrorInterceptorBase implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((httpError: HttpErrorResponse) => {
        if (!AuthService.refreshing && httpError.status === 401) {
          this.handleUnauthorized(httpError.error);
        }

        return throwError(httpError);
      })
    );
  }

  protected abstract handleUnauthorized(error: ApiError): void;
}
